import { ReactComponent as DoubleCheckIcon } from './double_check.svg';

export default DoubleCheckIcon;
